import { environment } from '../../environments/environment';
import axios from 'axios';
import type { AxiosResponse } from 'axios';
import debug from 'debug';
import { ChainalysisService } from './ChainalysisService';

const enum Rating {
  Unknown = 'unknown',
  LowRisk = 'lowRisk',
  HighRisk = 'highRisk',
}

type CARiskRating = {
  network?: string,
  asset?: string,
  address?: string,
  cluster?: {
    name?: string,
    category?: string,
  },
  rating?: Rating,
  customAddress?: string,
  chainalysisIdentification?: {
    addressName?: string,
    description?: string,
    categoryName?: string,
  },
};

type CAResponse = CARiskRating[];

const log = debug('app:services:RestChainalysisService');

const instance = axios.create({
  baseURL: environment.chainalysisUrl,
  timeout: 10000,
  headers: {
    Token: environment.chainalysisApiKey,
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: true,
});

/**
 * Fetch risk rating
 * https://docs.chainalysis.com/api/kyt/#withdrawal-pre-screening-register-withdrawal-addresses
 * @param walletAddress
 */
async function registerWithdrawalAddress(walletAddress: string): Promise<CARiskRating | null> {
  const path = 'users/'+walletAddress+'/withdrawaladdresses';

  try {
    const result = await instance.post<any, AxiosResponse<CAResponse>>(environment.chainalysisUrl + path, [{
      network: 'Ethereum',
      asset: 'ETH',
      address: walletAddress,
    }]);
    const metadata = result.data?.[0];
    if (!metadata) {
      throw new Error('Chainalysis data not found');
    }

    return metadata;
  } catch (e) {
    log('Error occurred:', e);
    return null;
  }
}

export class RestChainalysisService implements ChainalysisService {
  async isWalletAddressSafe(walletAddress: string): Promise<boolean> {
    const data = await registerWithdrawalAddress(walletAddress);
    if (!(data?.rating)) {
      // assume true if no data is returned or no rating is assigned
      return true;
    }
    return data.rating === Rating.LowRisk || data.rating === Rating.Unknown;
  }
}
